"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        listStyle: 'none',
        paddingLeft: 0,
        marginLeft: 0,
        color: constants_1.PROSE_COLOR,
        fontSize: constants_1.PROSE_FONT_SIZE,
        fontWeight: constants_1.PROSE_FONT_WEIGHT,
        lineHeight: constants_1.PROSE_LINE_HEIGHT,
        '&[data-is-light=true]': {
            color: constants_1.PROSE_COLOR_LIGHT
        },
        '&[data-is-small=true]': {
            fontSize: constants_1.PROSE_FONT_SIZE_SMALL,
            lineHeight: constants_1.PROSE_LINE_HEIGHT_SMALL
        },
        '&[data-break-after=true]::after': {
            content: '" "',
            whiteSpace: 'pre',
            display: 'block'
        },
        '& > li': {
            fontSize: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            display: 'flex',
            whiteSpace: 'pre',
            marginBottom: 3,
            '&::before': {
                content: '"·"',
                display: 'block',
                marginRight: 7
            },
            '& strong': {
                fontWeight: constants_1.PROSE_FONT_WEIGHT_BOLD
            }
        },
        '&[data-is-ordered=true]': {
            counterReset: 'proseList',
            '& > li': {
                '&::before': {
                    counterIncrement: 'proseList',
                    content: 'counter(proseList)"."',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: 14
                }
            }
        }
    }
};
//# sourceMappingURL=prose.list.style.js.map